import React from 'react'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import { useHistory } from 'react-router-dom'
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Button,
} from '@material-ui/core'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import { MoreVert } from '@material-ui/icons'
import { ReactComponent as ChatIcon } from '../../../assets/img/icons/comments.svg'

const PendingRequests = ({
  projects,
  handleDeleteClick,
  handleEditViewClick,
}) => {
  const history = useHistory()

  const Row = ({ project }) => {
    const handleDoubleClick = () => {
      handleEditViewClick(project)
    }

    return (
      <TableRow onDoubleClick={handleDoubleClick}>
        <TableCell>
          <div className="fs14">{project.name}</div>
          <div className="fs10 gray-text">Contract {project.type}</div>
        </TableCell>
        <TableCell>
          <div className="flex align-center">
            {project.assigneeInitials && (
              <div className="name-dot m-r-8 ">{project.assigneeInitials}</div>
            )}
            <p className="m-b-0 fs14">{project.assigneeName}</p>
          </div>
        </TableCell>

        <TableCell>{project.status}</TableCell>
        <TableCell>
          {useDateFormatter(project.updatedAt, 'MM-DD-YYYY')}
        </TableCell>

        <TableCell className="actions" align="right">
          {project.hasUnreadActivity && <ChatIcon className="m-l-20 m-r-8" />}

          <ActionsMenu
            icon={<MoreVert />}
            options={[
              {
                onClick: () => handleEditViewClick(project),
                label: 'Edit/View',
              },
              {
                onClick: () => handleDeleteClick(project),
                label: 'Delete',
              },
            ]}
          />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <div className="title-bar m-b-25">
        <div className="title">Pending requests</div>
        <div className="actions">
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/createaquote')}
          >
            Add new
          </Button>
        </div>
      </div>
      <>
        <TableContainer className="pending-requests-table">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Quote name</TableCell>
                <TableCell>Assignee</TableCell>

                <TableCell>Status</TableCell>
                <TableCell>Last updated</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projects &&
                projects.map((project, index) => (
                  <Row key={index} project={project} index={index} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    </>
  )
}

export default PendingRequests
